/**
 * Jinggangshan secondary-development module.
 * Scope: light, office-friendly stylesheet used when copying chat content to the
 * clipboard, so pasting into Word / WPS / Excel never produces dark-background
 * white text (the app default theme is dark).
 *
 * Additive-only: nothing here changes how the app itself renders.
 */

/** DOM 属性标记：只有落在带这个属性的容器内的选区才会被"净化"复制处理。 */
export const JGS_CLEAN_COPY_ATTR = 'data-jgs-clean-copy';

/** 选择器（供外部判断用）。 */
export const JGS_CLEAN_COPY_SELECTOR = `[${JGS_CLEAN_COPY_ATTR}]`;

/**
 * 供剪贴板 text/html 使用的浅色样式。
 * 颜色与导出的 Word / Excel 保持同一套色板，保证"复制"和"导出"观感一致。
 */
export const JGS_EXPORT_CSS = `
  body,div,section,article,p,span,li,td,th,blockquote,h1,h2,h3,h4,h5,h6 {
    background: #ffffff !important;
    color: #1f2328 !important;
    font-family: "Microsoft YaHei", "PingFang SC", "Segoe UI", Arial, sans-serif;
    font-size: 10.5pt;
    line-height: 1.6;
  }
  h1 { font-size: 16pt !important; color: #1d4ed8 !important; font-weight: 700 !important; margin: 12pt 0 6pt; }
  h2 { font-size: 13.5pt !important; color: #1d4ed8 !important; font-weight: 700 !important; margin: 10pt 0 5pt; }
  h3 { font-size: 12pt !important; color: #1f2328 !important; font-weight: 700 !important; margin: 9pt 0 4pt; }
  h4,h5,h6 { font-size: 11pt !important; color: #1f2328 !important; font-weight: 700 !important; }
  p,li,td,th { margin: 0 0 4pt; }
  ul,ol { margin: 4pt 0 4pt 18pt; padding: 0; }
  table { border-collapse: collapse !important; width: 100% !important; margin: 6pt 0; }
  th,td { border: 1px solid #d1d5db !important; padding: 4pt 6pt !important; vertical-align: top; }
  th { background: #f3f4f6 !important; font-weight: 700 !important; }
  code,kbd,samp,pre {
    font-family: Consolas, "Courier New", monospace !important;
    background: #f6f8fa !important;
    color: #24292e !important;
    font-size: 9.5pt !important;
  }
  pre { border: 1px solid #e1e4e8 !important; padding: 6pt !important; white-space: pre-wrap; }
  blockquote {
    margin: 4pt 0 !important;
    padding-left: 8pt !important;
    border-left: 3px solid #d1d5db !important;
    color: #4b5563 !important;
  }
  a { color: #338aff !important; text-decoration: underline !important; }
  img { max-width: 100%; }
  sup { color: #338aff !important; font-weight: 700 !important; }
  hr { border: none; border-top: 1px solid #d1d5db !important; }
`;

/** 需要清除的内联样式属性（浏览器复制时会带上暗色主题的计算值）。 */
export const JGS_STRIP_STYLE_PROPS = [
  'background',
  'background-color',
  'background-image',
  'color',
  'caret-color',
  'border-color',
  '-webkit-text-fill-color',
] as const;
